const charactersAndNumbersSeparator = (string: string) => {
  const [word, digits] = string.match(/\D+|\d+/g);
  return { word, digits };
};

export default charactersAndNumbersSeparator;
